import { IFormSection } from "../../../types/common";
import { API_LOAN_APPLICATIONS_RESCHEDULE } from "../../../utils/apis";
import { URL_LOAN_APPLICATIONS_RESCHEDULE } from "../../../utils/urls";
import { useLoanPeriodFields } from "../useLoanApplicationForm";

export const useRescheduleForm = ({ form, updateFormValue }) => {
  const { fields: loanPeriodFields, options: loanPeriodOptions } =
    useLoanPeriodFields({
      form,
      updateFormValue,
    });
  const sections: IFormSection[] = [
    {
      title: "Loan Particulars",
      fields: [
        ...loanPeriodFields,
        {
          field_name: "disbursement_date",
          type: "date",
          label: "Start Date",
        },
        {
          field_name: "reason_for_rescheduling",
          type: "textarea",
          label: "Reason for Rescheduling",
          props: { wide: true, required: true },
        },
      ],
    },
  ];

  const options = {
    ...loanPeriodOptions,
  };
  const redirect = `${URL_LOAN_APPLICATIONS_RESCHEDULE}/submitted`;

  return { sections, options, redirect };
};

export function submitLoanApplicationReschedule(
  payload: any,
  id: number | null,
  form_params: any,
) {
  const { application_id } = form_params;
  return {
    api: API_LOAN_APPLICATIONS_RESCHEDULE,
    id,
    params: { ...payload, loan_application: application_id },
  };
}
